/**
 * @generated SignedSource<<b736e9d7759917bdfdbf01a566600158>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ResendInvoiceInput = {
  clientMutationId?: string | null;
  orderId: string;
};
export type invoiceEmailActions_ResendInvoiceMutation$variables = {
  input: ResendInvoiceInput;
};
export type invoiceEmailActions_ResendInvoiceMutation$data = {
  readonly Admin: {
    readonly Billing: {
      readonly resendInvoice: {
        readonly clientMutationId: string | null;
        readonly sentToInvoiceEmail: string;
      } | null;
    };
  };
};
export type invoiceEmailActions_ResendInvoiceMutation = {
  response: invoiceEmailActions_ResendInvoiceMutation$data;
  variables: invoiceEmailActions_ResendInvoiceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BillingAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Billing",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "ResendInvoicePayload",
            "kind": "LinkedField",
            "name": "resendInvoice",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sentToInvoiceEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "invoiceEmailActions_ResendInvoiceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "invoiceEmailActions_ResendInvoiceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "95f55411c221a213f81d32261376cba9",
    "id": null,
    "metadata": {},
    "name": "invoiceEmailActions_ResendInvoiceMutation",
    "operationKind": "mutation",
    "text": "mutation invoiceEmailActions_ResendInvoiceMutation(\n  $input: ResendInvoiceInput!\n) {\n  Admin {\n    Billing {\n      resendInvoice(input: $input) {\n        sentToInvoiceEmail\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9dc8d6f81d9f640317ee899fbe0799da";

export default node;
